<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="job_board">Unlimited Job Board Posts</h2>
        <div class="flex lg:hidden justify-center my-4">
            <img 
                src="/proposal-presentation-files/img/job-board-posts.png" 
                alt="Job Board Posts" 
                class="cursor-pointer" 
                style="max-height: 200px"
                @click="enlargeImage"
            >
        </div>
        <div class="hidden lg:flex relative">
            <img 
                src="/proposal-presentation-files/img/job-board-posts.png" 
                alt="Job Board Posts" 
                class="absolute -top-2 z-10 right-0 duration-500 hover:scale-110 cursor-pointer" 
                style="max-height: 225px"
                @click="enlargeImage"
            >
        </div>
        <div class="flex gap-x-4 bg-white shadow p-6 lg:p-8 tr-box lg:mt-4 lg:mb-20">
            <ul class="tr-bullets ml-4 flex flex-col gap-y-2 lg:gap-y-4 lg:max-w-lg xl:max-w-3xl">
                <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
            </ul>
        </div>

        <proposal-modal-image
            v-if="modalImage"
            :modal-image-url="modalImageUrl"
            :modal-image-container="modalImageContainer"
            @close="modalImage = false"
        />
    </div>
</template>

<script>
import ProposalModalImage from "./proposal-modal-image";
import sellingPointMixin from '../sellingPointMixin';

export default {
    components: {
        ProposalModalImage,
    },
    mixins: [
        sellingPointMixin
    ],
    props: [
        'section',
    ],
    computed: {
        bullets() {
            return this.formatBullets(this.section.content);
        },
    },
}
</script>